import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utilities/axiosInstance";

const initialState = {
  countries: [],
  selectedCountry: null,
  isLoading: false,
  error: null,
};

export const fetchCountries = createAsyncThunk(
  "countries/fetchCountries",
  async (_, thunkAPI) => {
    try {
      const { data } = await axiosInstance.get(`/static/countries`);
      return thunkAPI.fulfillWithValue(data.data);
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  }
);

const countriesSlice = createSlice({
  name: "countries",
  initialState,
  reducers: {
    setSelectedCountry: (state, action) => {
      state.selectedCountry = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCountries.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchCountries.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.countries = payload;
        state.error = null;
      })
      .addCase(fetchCountries.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message || "Failed to fetch countries.";
      });
  },
});

export const { setSelectedCountry } = countriesSlice.actions;

// Selector to get currency by country code
export const selectCurrencyByCountry = (state, countryCode) => {
  if (!countryCode || !state.countries.countries.length) {
    return "KWD"; // Default currency
  }

  const country = state.countries.countries.find(
    (c) => c.code?.toUpperCase() === countryCode.toUpperCase()
  );

  return country?.currency || "KWD";
};

// Selector to get localized country name by country code
export const selectCountryName = (state, countryCode, lang = 'ar') => {
  if (!countryCode || !state.countries.countries.length) {
    return countryCode; // Fallback to code
  }

  const country = state.countries.countries.find(
    (c) => c.code?.toUpperCase() === countryCode.toUpperCase()
  );

  if (!country) return countryCode;

  return lang === 'ar' ? country.countryAr : country.countryEn;
};

export default countriesSlice.reducer;
